export default function CourseTerms() {
    return (
        <>
            <section id="guitar-course-details-section">
                <div className="guitar-course-details-container">
                    <div className="guitar-course-details-content">
                        <div className="course-detail-item">
                            <h3 className="course-detail-title">TRAINING INVOLVES</h3>
                            <div className="course-detail-underline"></div>
                            <ul className="course-detail-list">
                                <li>Voice culture and playback singing techniques.</li>
                                <li>Expression, emotion, and improvisation.</li>
                                <li>Microphone techniques and studio recording practice.</li>
                                <li>Classical-influenced ornamentations for Bollywood songs.</li>
                                <li>Stage performance and live concert readiness.</li>
                            </ul>
                        </div>
                        <div className="course-detail-item">
                            <h3 className="course-detail-title">Who is it For</h3>
                            <div className="course-detail-underline"></div>
                            <ul className="course-detail-list">
                                <li>Aspiring playback singers aiming for the industry.</li>
                                <li>Hobbyists and Bollywood music lovers.</li>
                                <li>Students seeking versatile singing skills.</li>
                                <li>- Performers preparing for stage or reality shows.</li>
                            </ul>
                        </div>

                        <div className="course-detail-item">
                            <h3 className="course-detail-title">Learning Outcomes</h3>
                            <div className="course-detail-underline"></div>
                            <ul className="course-detail-list">
                                <li>Authentic playback singing style.</li>
                                <li>Confidence in singing both Bollywood classics and modern hits.</li>
                                <li>Performance and recording-readiness.</li>
                                <li>Development of unique personal singing style.</li>
                            </ul>
                        </div>
                    </div>
                </div>
            </section>
        </>
    );
} 